import "./App.css";
import { Routes, Route, useLocation,Navigate } from "react-router-dom";
import { Home, Account, Calls, Error, LandingPage,ProtectedRoute, SubsriptionPacks, SubscriptionResponseModal, Campion, Language } from "./components/index";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { isFacebookCampaign } from "./utils/Helpers";
import { initSession } from "./utils/session";
import NotAllowed from "./components/NotAllowed";

function App() {
  // const { pathname } = useLocation();
  console.log("Current pathname::", window.location.pathname);
  useEffect(() => {
    initSession();
    const lang=localStorage.getItem("lang");
    if(!lang)
      {
        localStorage.getItem("lang",'en');
      }
    ReactGA.initialize("G-K2ZT8LX1FV");
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Page Viewed",
    });
  }, []);
  return (
    <div className="app ">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/account" element={isFacebookCampaign() ? <Navigate to="/home" replace /> : <Account />} />
        <Route path="/calls" element={<ProtectedRoute component={Calls} />} />
        <Route path="/home" element={<Home/>}/>
        <Route path="/language" element={<ProtectedRoute component={Language}/>}/>
        <Route path="/subs/packs" element={<SubsriptionPacks />} /> 
        <Route path="/subs/modal" element={<SubscriptionResponseModal />} />   
        <Route path="/not-allowed" element={<NotAllowed/>}/>
        <Route path="*"element={<Navigate to="/" replace />}/>
      </Routes>
    </div>
  );
}

export default App;
